/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@express-labs/raven-ui';
import { cn } from '@express-labs/raven-tools';
import s from './AddCodeButton.module.scss';

function AddCodeButton({
  promoCodeAdded, handleSubmit, iconName, iconClassname, label,
}) {
  if (promoCodeAdded) {
    return (
      <span className={s.text}>
        <span className={cn(s.icon, iconClassname)}>
          <Icon icon={iconName} />
        </span>
        <span className={s.label}>{label}</span>
      </span>
    );
  }

  return (
    <Button onClick={handleSubmit} chroma="light" className={s.link}>
      <span className={cn(s.icon, iconClassname)}>
        <Icon icon={iconName} />
      </span>
      <span className={s.label}>{label}</span>
    </Button>
  );
}

AddCodeButton.propTypes = {
  promoCodeAdded: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  iconName: PropTypes.string.isRequired,
  iconClassname: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default AddCodeButton;
